<template>
  <div class="h-full flex flex-col flex-1">
    <SeeAndCheck
      v-if="finalFace.type === KidHanziCardFaceType.SeeAndCheck"
      :face="finalFace"
    />

    <VoiceChoice
      v-else-if="finalFace.type === KidHanziCardFaceType.VoiceChoice"
      :face="finalFace"
    />

    <ClozeChoice
      v-else-if="finalFace.type === KidHanziCardFaceType.ClozeChoice"
      :face="finalFace"
    />
  </div>
</template>

<script lang="ts" setup>
import SeeAndCheck from './faces/SeeAndCheck.vue'
import VoiceChoice from './faces/VoiceChoice.vue'
import ClozeChoice from './faces/ClozeChoice.vue'

import { KidHanziCardFaceType, type KidHanziCardFace } from '@/types/core'
import { processKidHanziFace } from '@/utils/card'

const props = defineProps<{
  face: KidHanziCardFace
}>()

const finalFace = processKidHanziFace(props.face)
</script>

<style scoped></style>
